<template>
  <div class="c-table" ref="designExpendtable">
    <el-table class="common-el-table-styles" :data="data" :height="height" border stripe :cell-class-name="cellClassName">
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
      >
        <template slot-scope="scope">
          <span v-if="col.key === 'reportMonth'">{{ scope.row[col.key] }}</span>
          <div v-else-if="col.key === 'control'">
            <Poptip confirm transfer title="您确认删除该素材消耗吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">&ensp;删除</el-button>
            </Poptip>
          </div>
          <div v-else-if="col.key === 'thirtyDaysAmount'">
            <div v-if="scope.row.edit">
              <el-input v-model.trim="scope.row.newThirtyDaysAmount" placeholder="" class="m-edit-input" />
              <Button type="primary" size="small" style="padding: 0 3px" :loading="scope.row.loading" @click="$emit('on-save', scope.row)">
                确定
              </Button>
              <Button size="small" style="padding: 0 3px" @click="cancelEdit(scope.row)"> 取消 </Button>
            </div>
            <div v-else>
              <span>{{ scope.row[col.key] | toThousands }}</span>

              <Icon @click="changEdit(scope.row)" type="md-create" class="g-pull-right m-edit" size="18" color="#409EFF" />
            </div>
          </div>
          <span v-else-if="col.key === 'imageCreateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'updateTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToSec }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'designExpendTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    cellClassName({ column }) {
      if (column.property === 'thirtyDaysAmount') return 'thirty-days-amount-cell'
      return ''
    },
    // 改变编辑状态
    changEdit(row) {
      this.data.forEach((ret) => {
        this.$set(ret, 'edit', false)
      })
      this.$set(row, 'newThirtyDaysAmount', row.thirtyDaysAmount)
      this.$set(row, 'edit', true)
    },
    cancelEdit(row) {
      this.$set(row, 'loading', false)
      this.$set(row, 'edit', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.c-table {
  ::v-deep .el-table {
    height: 100%;

    .thirty-days-amount-cell {
      position: relative;
      &:hover {
        .m-edit {
          display: block;
        }
      }
      .m-edit {
        position: absolute;
        top: 50%;
        right: 5px;
        display: none;
        transform: translateY(-50%);
        cursor: pointer;
      }
    }

    .m-edit-input {
      width: 108px;

      input {
        padding-left: 8px;
      }
    }
  }
}
</style>
